module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-transparent-bg-gold-300x300.75e85c49.png";